import React from 'react';
import { Button } from 'antd';

type PrimaryButton = {
  title?: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  children?: string | JSX.Element;
  type?: 'submit' | 'reset' | 'button';
  // eslint-disable-next-line
  style?: any;
  loading?: boolean;
  hidden?: boolean;
};

const PrimaryButton = ({
  title,
  onClick,
  className,
  disabled,
  children,
  type = 'submit',
  style,
  loading = false,
  hidden = false,
}: PrimaryButton): JSX.Element => (
  <Button
    onClick={onClick}
    disabled={disabled}
    htmlType={type}
    type="primary"
    className={`${className || ''}`}
    style={style || {}}
    loading={loading}
    hidden={hidden}
  >
    {title || children}
  </Button>
);

PrimaryButton.displayName = 'PrimaryButton';

export default PrimaryButton;
